// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Nq-z","imageAndVideoCount":"Oq-z","imageAndVideoContainer":"Pq-z","viewAllReviews":"Qq-z"};